export default __webpack_public_path__ + "1373045162788f1f083b5f6599246a23.wasm";